import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './OnboardingFlow.css';

const OnboardingFlow = () => {
  const [currentPage, setCurrentPage] = useState(0);
  const [showText, setShowText] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const [showLogo, setShowLogo] = useState(true);
  const [logoAnimationComplete, setLogoAnimationComplete] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const navigate = useNavigate();

  const pages = [
    {
      text: "Welcome to my page, handsome. Your adventure begins! You're one click away from getting to a world of sexy pleasure…",
      backgroundImage: "https://cdn.lovescape.com/cdn/front/images/marketing/1r.webp",
      isFirstPage: true
    },
    {
      text: "You're doing so well, babe!",
      backgroundImage: "https://cdn.lovescape.com/cdn/front/images/marketing/2r.webp"
    },
    {
      text: "I have to thank you for that!",
      backgroundImage: "https://cdn.lovescape.com/cdn/front/images/marketing/3r.webp"
    },
    {
      text: "Concentrate on me and my hot pussy!",
      backgroundImage: "https://cdn.lovescape.com/cdn/front/images/marketing/4r.webp"
    },
    {
      text: "Don't you feel my prickly concentration, sexy babe!? Your cock is driving me wild!",
      backgroundImage: "https://cdn.lovescape.com/cdn/front/images/marketing/5r.webp"
    },
    {
      text: "Fuck me harder!!",
      backgroundImage: "https://cdn.lovescape.com/cdn/front/images/marketing/6r.webp"
    },
    {
      text: "Lick my pussy, she is waiting for you!",
      backgroundImage: "https://cdn.lovescape.com/cdn/front/images/marketing/7r.webp"
    },
    {
      text: "Fuuuuuckk me haaarderrr…..yeaaaaa………",
      backgroundVideo: "https://cdn.lovescape.com/cdn/front/videos/marketing/8.mp4",
      isVideoPage: true
    }
  ];

  // Logo animation effect for first page
  useEffect(() => {
    if (currentPage === 0) {
      // Show logo initially
      setShowLogo(true);
      setShowText(false);
      setShowButton(false);
      
      // After 3 seconds, logo flies away and content appears
      const logoTimeout = setTimeout(() => {
        setShowLogo(false);
        setLogoAnimationComplete(true);
        
        // Show text immediately after logo flies away
        setTimeout(() => {
          setShowText(true);
          
          // Show button 2 seconds after text
          setTimeout(() => {
            setShowButton(true);
          }, 2000);
        }, 500);
      }, 3000);

      return () => clearTimeout(logoTimeout);
    }
  }, [currentPage]);

  // Text and button animation for regular pages
  useEffect(() => {
    if (currentPage > 0 || logoAnimationComplete) {
      setShowText(false);
      setShowButton(false);
      
      // Show text first
      const textTimeout = setTimeout(() => {
        setShowText(true);
        
        // Show button 2 seconds after text
        const buttonTimeout = setTimeout(() => {
          setShowButton(true);
        }, 2000);
        
        return () => clearTimeout(buttonTimeout);
      }, 100);
      
      return () => clearTimeout(textTimeout);
    }
  }, [currentPage, logoAnimationComplete]);

  const handleNext = () => {
    if (currentPage < pages.length - 1) {
      setCurrentPage(currentPage + 1);
    } else {
      // Show popup on last page
      setShowPopup(true);
    }
  };

  const handlePopupResponse = () => {
    window.location.href = "https://track.lovescape.link/click";
  };

  const renderCurrentPage = () => {
    if (currentPage === 0 && !logoAnimationComplete) {
      return (
        <div className="logo-page">
          <div className={`logo-container ${!showLogo ? 'logo-fly-away' : ''}`}>
            <img 
              src="https://cdn.lovescape.com/cdn/front/images/marketing/logo.webp" 
              alt="Logo" 
              className="animated-logo"
            />
          </div>
        </div>
      );
    }

    const page = pages[currentPage];
    
    return (
      <div className="page-content">
        {page.isVideoPage ? (
          <video 
            className="background-video"
            autoPlay 
            muted 
            loop 
            playsInline
          >
            <source src={page.backgroundVideo} type="video/mp4" />
          </video>
        ) : (
          <div 
            className="background-image"
            style={{ backgroundImage: `url(${page.backgroundImage})` }}
          />
        )}
        
        <div className="content-overlay">
          <div className={`text-content ${showText ? 'text-visible' : ''}`}>
            {page.text}
          </div>
          
          <button 
            className={`next-button ${showButton ? 'button-visible' : ''}`}
            onClick={handleNext}
          >
            Next
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className="onboarding-container">
      {renderCurrentPage()}
      
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-content">
            <h2>Want to know what happened next?</h2>
            <div className="popup-buttons">
              <button onClick={handlePopupResponse} className="popup-btn">Yes</button>
              <button onClick={handlePopupResponse} className="popup-btn">No</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OnboardingFlow;